<template>
    <v-card tile :loading="loading" style="margin-top:100px">
        <v-card-title class="secondary-color">
            <b>{{ $t('AvailableSurveys') }}</b>
            <v-spacer />
            <router-link :to="{ name: 'landing'}" custom>
                <v-btn fab small class="white--text" color="secondary" role="link">
                    <v-icon>mdi-arrow-left-circle</v-icon>
                </v-btn>
            </router-link>
        </v-card-title>

        <v-card-text>
            <v-container>
                <v-row>
                    <v-col col="3" md="3" sm="3" xs="6" v-for="(survey, index) in results" :key="index">
                        <v-card class="elevation-3 cardtitle" tile style="width:unset; background-color:transparent">
                            <v-card-title class="cardtitle" style="width:unset; background-color:transparent">{{ survey.name }}</v-card-title>
                            <v-card-text>
                                <div class="my-2" style="height:60px">
                                    {{ survey.description.length > 150 ? survey.description.substring(0, 150) :  survey.description }}
                                </div>
                            </v-card-text>
                            <v-divider class="mx-4"></v-divider>
                            <v-card-actions>
                                <v-chip class="ms-2" color="secondary">{{ $t('Open') }}</v-chip>
                                <v-spacer></v-spacer>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <router-link v-if="!survey.voted" class="mx-3 text-decoration-none" :to="{ name: 'public-survey-form', query: { id: survey.id,participantId:survey.participantId }}" custom>
                                            <b class="me-3" v-bind="attrs" v-on="on">{{ survey.participantId?$t('ContinueSurvey'):$t('StartSurvey')}}</b><v-icon color="primary" v-bind="attrs" v-on="on">mdi-vote-outline</v-icon>
                                        </router-link>
                                        <v-chip v-else class="ms-2" color="error">{{ $t('Voted') }}</v-chip>
                                    </template>

                                    <span> {{ $t('Vote') }}</span>
                                </v-tooltip>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
    import { mapGetters } from 'vuex'
    import SurveyService from '@/services/SurveyService.js'
    import Cookies from 'js-cookie'
    import SettingsService from '@/services/SettingsService'

    export default ({
        components: {
        },
        data() {
            return {
                results: [],
                loading: false,
            }
        },
        created() {
            this.listHomePageSurveys()
        },
        computed: {
            ...mapGetters('user', ['language']),

            getLanguage() {
                return this.language == null ? 'ar' : this.language
            },
        },
        methods: {
            async listHomePageSurveys() {
                this.loading = true
                var votescount = await SettingsService.getSurveyAttendancePerUser()
                SurveyService.listHomePageSurveys(this.getLanguage).then((res) => {
                    this.results = res.data
                    var voted = Cookies.get('surveysVoted')
                    var answers = Cookies.get('savedSurveyAnswers')
                    var savedSurveyAnswers = []
                    var surveysVoted = []
                    if (voted) {
                        surveysVoted = JSON.parse(voted)
                    }
                    if (answers) {
                        savedSurveyAnswers = JSON.parse(answers)
                    }
                    this.results.map(survey => {
                        var votedfound = surveysVoted.filter(x => x.surveyId == survey.id)
                        if (votedfound.length > 0) {
                            survey.voted = votedfound[0].count >= votescount.data
                        }
                        var found = savedSurveyAnswers.filter(x => x.surveyId == survey.id)
                        if (found.length > 0) {
                            survey.participantId = found[0].participantId
                        }
                    })
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            }
        },
    })
</script>

<style>
</style>